import history from './history'

export default function redirect(url: string): void {
  if (url.match(/^(https?:\/\/id\.rambler\.ru)?\/account\//)) {
    history.push(url.replace(/^https?:\/\/id\.rambler\.ru/, ''))
  } else {
    window.location.href = url
  }
}
